import {
	createApp
} from 'vue'
import router from './router';
import App from './App.vue'
import './res/style/reset.less';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

const whiteList = ['/login', '/register', '/forget'] //路由白名单

router.beforeEach(async (to, from, next) => {
	const hasToken = localStorage.getItem('token');
	if (hasToken) {
		if (to.path === '/login') {
			next('/');
		} else {
			next();
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next();
		} else {
			next('/login');
		}
	}
})
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
app.use(ElementPlus).use(router);
/***
    1、公共变量定义（接口地址，图片地址）
    2、api接口文件(api.js)
    3、res/style/index样式文件
    4、public/index.html文件，title标题，浏览器icon
 ***/
const currentHost = window.location.hostname; // 获取当前主机名
const protocol = window.location.protocol; // 获取当前协议
function checkDomain(hostname) {
	return hostname.includes('hz') ? 2 : 1;
}
const isMatch = checkDomain(currentHost);
app.config.globalProperties.$getCurrentHost = isMatch;
if (isMatch === 1) { //南昌机房
	app.config.globalProperties.$JFType = 1;
	app.config.globalProperties.$globalFileUrl = currentHost == "localhost" ? 'http://web.taoqimao.cn' :
		protocol + '//' + currentHost;
	app.config.globalProperties.$globalImgUrl = 'http://taoqimao.cn'; //图片地址
	app.config.globalProperties.$globalIframe = 'https://yk.taoqimao.cn'; //群控地址
} else if (isMatch === 2) { //杭州机房
	app.config.globalProperties.$JFType = 2;
	app.config.globalProperties.$globalFileUrl = protocol + '//' + currentHost;
	app.config.globalProperties.$globalImgUrl = 'https://hz1.taoqimao.cn'; //图片地址
	app.config.globalProperties.$globalIframe = 'https://t2.taoqimao.cn'; //群控地址
}
app.config.globalProperties.$globalTitle = '淘气猫云手机';

app.mount('#app');